export default __webpack_public_path__ + "static/media/property_93.08584d75.png";